import React from 'react';
import './Map.css';
import Section from "../../../../components/Clientes/Section/Section";
import {ReactComponent as MapIcon} from "../../../../assets/systemIcons/map.svg"

function Map() {
    return (
        <Section>
            <MapIcon className="clientes__map__svg" />
            <div className="clientes__map__container">
                <div className="clientes__map__titleContainer">
                    <h1 className="clientes__map__title">Productores en todo el país</h1>
                    <h2 className="clientes__map__description">
                        Desde cualquier rincón de Argentina, contá con el acompañamiento de un productor certificado cerca tuyo.
                    </h2>
                </div>
                <div className="clientes__map__statsContainer">
                    <ul className="clientes__map__stats">
                        <li className="clientes__map__stat">
                            <span className="clientes__map__statValue">+ 10.000</span>
                            <span className="clientes__map__statLabel">Cotizaciones por mes</span>
                        </li>
                        <li className="clientes__map__stat">
                            <span className="clientes__map__statValue">+ 18.000</span>
                            <span className="clientes__map__statLabel">Seguros vendidos</span>
                        </li>
                        <li className="clientes__map__stat">
                            <span className="clientes__map__statValue">+ 800</span>
                            <span className="clientes__map__statLabel">Productores en todo el país</span>
                        </li>
                        <li className="clientes__map__stat">
                            <span className="clientes__map__statValue">Más de 10</span>
                            <span className="clientes__map__statLabel">Compañías para cotizar</span>
                        </li>
                    </ul>
                </div>
            </div>
        </Section>
    );
}

export default Map;